import { useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { FormGroup } from '@shared/ui/forms/display';
import { Input } from 'rsuite';
import { ThemeButton } from '@shared/ui/buttons';
import { DialogContent, DialogActions } from '@mui/material';
import { useEffect, useState } from 'react';
import Note from '@shared/ui/messages/Note';
import TabsComponent from '@shared/ui/TabsComponent';
import {
  useRequestTwofaDialog,
  useAddChannelDialog,
} from '@utils/dialogs-hooks';
import { SelectNetworkInput, BasicInput } from '@shared/ui/forms/inputs';
import { useTopUp } from '@app/api/cards/useTopUp';
import { validateServerErrors, teamNameRule } from '@utils/validation';
import { useChannel } from '@app/api/profile/useChannel';

export default function AddChannelDialog({
  close,
  setSubtitle,
  setTitle,
  data,
  errorsResponse,
  type,
}) {
  const {
    control,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      label: data?.label || '',
      currency: data?.currency || null,
      address: data?.address || '',
    },
  });

  const { user } = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const [tabValue, setTabValue] = useState(1);
  const { openRequestTwofaDialog } = useRequestTwofaDialog();
  const { fetchTopUpSettings } = useTopUp();
  const [topUpSettings, setTopUpSettings] = useState(null);
  const { createChannel, updateChannel } = useChannel();
  const { openAddChannelDialog } = useAddChannelDialog();

  const tabsOptions = [
    {
      label: 'Crypto network',
      value: 1,
    },
    {
      label: 'Wire',
      value: 2,
    },
  ];

  async function onSubmit(formData) {
    if (!user?.two_fa) return;
    if (type === 'update') {
      openRequestTwofaDialog(
        { id: data.id, ...formData },
        (err) => openAddChannelDialog(formData, err, 'update'),
        updateChannel,
      );
    } else {
      openRequestTwofaDialog(
        formData,
        (err) => openAddChannelDialog(formData, err),
        createChannel,
      );
    }
  }

  useEffect(() => {
    if (type === 'update') {
      setSubtitle('Crypto network');
      setTitle('Withdrawal channel');
    } else {
      setSubtitle(user.name);
    }
    fetchTopUpSettings(setTopUpSettings);
    validateServerErrors(setError, errorsResponse);
  }, []);

  return (
    <>
      <DialogContent>
        {type !== 'update' && (
          <Note type="warning" title="Title" content="Content" marginBottom />
        )}
        <div className="form">
          {type !== 'update' && (
            <TabsComponent
              value={tabValue}
              setValue={setTabValue}
              options={tabsOptions}
              fullWidth
            />
          )}
          {tabValue === 1 && (
            <>
              <BasicInput
                control={control}
                name="label"
                label="Nickname"
                placeholder="Enter nickname"
                error={errors.label}
                counter
                disabled={!user?.two_fa}
                validation={teamNameRule}
              />
              <SelectNetworkInput
                control={control}
                name="currency"
                label="Currency - Network"
                data={topUpSettings?.withdrawOptions}
                error={errors.currency}
                disabled={type === 'update'}
              />
              <BasicInput
                control={control}
                name="address"
                label="Wallet address"
                placeholder="Enter wallet address"
                icon="wallet-input"
                error={errors.address}
                disabled={type === 'update'}
                copyable={type === 'update'}
              />
            </>
          )}
          {tabValue === 2 && (
            <>
              <BasicInput
                control={control}
                name="name"
                label="Nickname"
                disabled={!user?.two_fa}
              />
              <BasicInput
                control={control}
                name="name"
                label="Name of the individual or company"
              />
              <BasicInput
                control={control}
                name="name"
                label="IBAN / Account number"
              />
              <BasicInput
                control={control}
                name="name"
                label="SWIFT / BIC code"
              />
              <FormGroup
                label="Address of the individual or company"
                error={errors.code}
              >
                <Controller
                  control={control}
                  name="nickname"
                  rules={{ required: true }}
                  render={({ field }) => (
                    <Input
                      value={field.value}
                      placeholder="Enter"
                      as="textarea"
                      rows={3}
                      onChange={(value) => field.onChange(value)}
                    />
                  )}
                />
              </FormGroup>
            </>
          )}
        </div>
      </DialogContent>
      {user?.two_fa && (
        <DialogActions>
          <ThemeButton
            onClick={handleSubmit(onSubmit)}
            icon="check"
            loading={isLoading}
            minWidth
          >
            {type === 'update' ? 'Save' : 'Create'}
          </ThemeButton>
        </DialogActions>
      )}
    </>
  );
}
